import PropTypes from 'prop-types'
import classNames from 'classnames'
import style from '@aytm/lib/rfd-ui/styles/SuggestionsComponent.module.scss'

const SuggestionItem = ({ suggestion, index, selectedIndex, selectSuggestion }) => (
  <div
    onMouseDown={event => {
      event.preventDefault()

      selectSuggestion(suggestion)
    }}
    id={'suggestion-item-' + index}
    className={classNames(style.item, {
      [style['item--active']]: index === selectedIndex
    })}
  >
    <div className={style['content']}>
      <div className={style['content-text']}>
        {suggestion.fuzzy ? (
          <span
            dangerouslySetInnerHTML={{
              __html: `${suggestion.label.replace(
                new RegExp(suggestion.fuzzy, 'i'),
                '<b>' + suggestion.fuzzy + '</b>'
              )}${suggestion.description != undefined ? ' (' + suggestion.description + ')' : ''}`
            }}
          />
        ) : (
          <>
            <b>{suggestion.label}</b>
            {suggestion.description != undefined ? ' (' + suggestion.description + ')' : ''}
          </>
        )}
      </div>
    </div>
  </div>
)

SuggestionItem.propTypes = {
  index: PropTypes.number,
  onSelect: PropTypes.func,
  suggestion: PropTypes.object,
  selectSuggestion: PropTypes.func,
  selectedIndex: PropTypes.number
}

export default SuggestionItem
